export class StorageBrowseOptions {
  public static defaultOptions(): StorageBrowseOptions {
    return StorageBrowseOptions.start()
  }

  public static start(): StorageBrowseOptions {
    return new StorageBrowseOptions()
  }

  constructor(
    public browsePath?: string,
    public browsableFacilities?: string[],
    public minLevelAllowed?: number,
    public maxLevelAllowed?: number,
    public selectableNodeIds?: string[],
    public selectionUpperLimitPath?: string
  ) {}

  public withBrowsePath(browsePath: string): StorageBrowseOptions {
    return new StorageBrowseOptions(
      browsePath,
      this.browsableFacilities,
      this.minLevelAllowed,
      this.maxLevelAllowed,
      this.selectableNodeIds,
      this.selectionUpperLimitPath
    )
  }

  public withBrowsableFacilities(browsableFacilities: string[]): StorageBrowseOptions {
    return new StorageBrowseOptions(
      this.browsePath,
      browsableFacilities,
      this.minLevelAllowed,
      this.maxLevelAllowed,
      this.selectableNodeIds,
      this.selectionUpperLimitPath
    )
  }

  public withSelectableNodeIds(selectableNodeIds: string[]): StorageBrowseOptions {
    return new StorageBrowseOptions(
      this.browsePath,
      this.browsableFacilities,
      this.minLevelAllowed,
      this.maxLevelAllowed,
      selectableNodeIds,
      this.selectionUpperLimitPath
    )
  }

  public withSelectionUpperLimitPath(selectionUpperLimitPath: string): StorageBrowseOptions {
    return new StorageBrowseOptions(
      this.browsePath,
      this.browsableFacilities,
      this.minLevelAllowed,
      this.maxLevelAllowed,
      this.selectableNodeIds,
      selectionUpperLimitPath
    )
  }
}
